<template>
	<div style="height: 100vh; overflow:auto;">
		<v-card flat v-show="editor">
			<v-card-text>
				<brace
					style="height:90vh;"
					class="kbet-editor"
					:mode="'json'"
					@code-change="onEditorCodeChange"
					@setHandler="
						h => {
							editorHandler = h;
						}
					"
				/>
			</v-card-text>
		</v-card>
		<v-card flat v-show="!editor" v-if="tableLogResult.length > 0">
			<div class="range-selection-wrapper">
				<div class="selection-type-wrapper">
					<v-btn-toggle
						color="blue"
						v-model="rowValiditySelectionValue"
						tile
						group
					>
						<v-btn depressed value="VALID">
							<!-- color="blue lighten-2"  -->
							Valid
						</v-btn>
						<v-btn depressed value="INVALID">
							Invalid
						</v-btn>
					</v-btn-toggle>
				</div>

				<div class="selection-range-input-wrapper">
					<v-text-field
						v-model="rangeInput.startValue"
						dense
						label="Start Index"
						:rules="onlyNumberRule"
					></v-text-field>
					<v-text-field
						v-model="rangeInput.endValue"
						dense
						label="End Index"
						:rules="onlyNumberRule"
					></v-text-field>
					<v-btn
						color="blue lighten-2"
						@click="selectSpecifiedRows"
						tile
						:disabled="disableRangeButton"
					>
						Select Specified Rows
					</v-btn>
				</div>
				<div class="action-button-wrapper">
					<v-btn
						color="blue lighten-2"
						@click="handleRowValidity"
						tile
						:disabled="!checkboxList.length"
					>
						Submit
					</v-btn>
					<v-btn
						color="blue lighten-2"
						@click="checkboxList = []"
						tile
						:disabled="!checkboxList.length"
					>
						Discard All
					</v-btn>
				</div>
			</div>
			<v-card-text>
				<div class="extracted-data-table" style="overflow-x:auto;">
					<div class="tableLight" id="results">
						<div class="theader">
							<div
								:class="[
									'table_header',
									'table_header_light',
									'edit-button-header',
								]"
							>
								Edit Row
							</div>
							<div
								class="checkbox-column"
								:class="['table_header', 'table_header_light']"
							>
								Select Row
							</div>
							<div :class="['table_header', 'table_header_light']">
								Index
							</div>
							<div
								:class="[
									'table_header',
									'table_header_light',
									'flag-container-header',
								]"
							>
								FLAG
							</div>
							<template v-for="head in Object.keys(tableLogResult[0])">
								<div
									v-if="
										head !== 'FLAG' &&
											head !== '_id' &&
											head !== 'STOCKIST_CODE'
									"
									:key="head"
									:class="['table_header', 'table_header_light']"
								>
									{{ head }}
								</div>
							</template>
							<div :class="['table_header', 'table_header_light']">
								_id
							</div>
							<div :class="['table_header', 'table_header_light']">
								STOCKIST_CODE
							</div>
						</div>
						<div
							v-for="(row, key) in tableLogResult"
							:key="key"
							:class="['table_row', row['RESULT'] != 0 ? 'mildRed' : '']"
						>
							<div class="table_small edit-button-container">
								<div class="table_cell">Edit Row</div>
								<div class="table_cell" style="text-align:center;">
									<v-btn
										color="blue lighten-4 row-edit-button"
										small
										tile
										@click="editRow(row)"
									>
										<v-icon>{{ 'edit' }}</v-icon>
									</v-btn>
								</div>
							</div>
							<div class="table_small">
								<div class="table_cell">Select Row</div>
								<div
									class="table_cell checkbox-item"
									style="text-align:center;"
								>
									<v-checkbox
										v-model="checkboxList"
										class="validity-checkbox"
										:value="row._id"
									></v-checkbox>
								</div>
							</div>
							<div class="table_small">
								<div class="table_cell">Index</div>
								<div
									class="table_cell"
									style="text-align:left;margin: 0 20px 0 0;"
								>
									{{ key + 1 }}
								</div>
							</div>
							<div
								:key="key + 'flag'"
								class="table_small flag-container"
								v-if="row['FLAG']"
							>
								<div class="table_cell">{{ key }}</div>
								<div
									class="table_cell"
									style="text-align:left;margin: 0 20px 0 0;"
								>
									{{ row['FLAG'] }}
								</div>
							</div>
							<template v-for="(rowItem, itemKey) in row">
								<div
									:key="itemKey"
									class="table_small"
									v-if="
										itemKey !== 'FLAG' &&
											itemKey !== '_id' &&
											itemKey !== 'STOCKIST_CODE'
									"
								>
									<div class="table_cell">{{ itemKey }}</div>
									<div
										class="table_cell"
										style="text-align:left;margin: 0 20px 0 0;"
									>
										{{ rowItem }}
									</div>
								</div>
							</template>
							<div :key="key + '_id'" class="table_small" v-if="row['_id']">
								<div class="table_cell">{{ key }}</div>
								<div
									class="table_cell"
									style="text-align:left;margin: 0 20px 0 0;"
								>
									{{ row['_id'] }}
								</div>
							</div>
							<div
								:key="key + 'STOCKIST_CODE'"
								class="table_small"
								v-if="row['STOCKIST_CODE']"
							>
								<div class="table_cell">{{ key }}</div>
								<div
									class="table_cell"
									style="text-align:left;margin: 0 20px 0 0;"
								>
									{{ row['STOCKIST_CODE'] }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</v-card-text>
			<v-dialog v-model="formDialog" max-width="800">
				<v-card>
					<v-card-title class="headline primary dialog-title" primary-title
						>Edit values for product -
						{{ selectedDataRowVitalInfo.PRODUCT_NAME }}
						{{
							selectedDataRowVitalInfo.PACKING !== 'NA'
								? ' (' + selectedDataRowVitalInfo.PACKING + ')'
								: ''
						}}
					</v-card-title>
					<v-card-text>
						<v-form v-model="isFormValid" class="input-field-wrapper">
							<div
								v-for="selectedDataKey of Object.keys(
									selectedDataRowFieldsInfo
								)"
								:key="selectedDataKey"
								class="input-field"
							>
								<v-text-field
									v-model="selectedDataRowFieldsInfo[selectedDataKey]"
									:label="selectedDataKey"
									:rules="
										selectedDataKey == 'PRODUCT_NAME' ||
										selectedDataKey == 'PACKING'
											? []
											: formInputRules
									"
									ma-2
									class="g2"
								></v-text-field>
							</div>
						</v-form>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" flat @click="closeModalAndClearState"
							>Cancel</v-btn
						>
						<v-btn
							color="orange darken-1"
							flat
							:disabled="!isFormValid"
							@click="handleSubmitClick"
							>Submit</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card>
		<v-btn
			color="primary darken-1"
			small
			absolute
			top
			right
			fab
			@click="toggleLogDisplay"
		>
			<v-icon>{{ editor ? 'table_chart' : 'code' }}</v-icon>
		</v-btn>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {},
	data() {
		return {
			editorHandler: false,
			displayJSON: false,
			editor: true,
			tableLogResult: [],
			resultSummary: {},
			formDialog: false,
			selectedDataRowFieldsInfo: {},
			selectedDataRowVitalInfo: {},
			listOfHeadersAllowedToEdit: [
				'OPENING',
				'OPENING_VALUE',
				'PURCHASE',
				'PURCHASE_FREE',
				'PURCHASE_RETURN',
				'PURCHASE_VALUE',
				'SALES',
				'SALES_FREE',
				'SALES_RETURN',
				'SALES_VALUE',
				'CLOSING',
				'CLOSING_VALUE',
				'PRODUCT_NAME',
				'PACKING',
				'RATE',
			],
			listOfVitalHeaders: ['_id', 'UUID', 'PRODUCT_NAME', 'PACKING'],
			formInputRules: [
				v =>
					v === 'NA' ||
					/^-?\d*[.]?\d+$/.test(v) ||
					'Input can only be NA or a Number',
			],
			isFormValid: false,
			rowValiditySelectionValue: 'INVALID',
			checkboxList: [],
			rangeInput: {
				startValue: '',
				endValue: '',
			},
			onlyNumberRule: [
				v => /^-?\d*[.]?\d+$/.test(v) || 'Input can only be a Number',
			],
		};
	},
	created() {},
	methods: {
		// ...mapMutations("extractedData", ["closeFileMetaDialog"]),
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog', 'openSnackbar']),
		...mapActions('reworkExtractedData', [
			'getExtractedOutput',
			'editExtractedDataRow',
			'updateValidity',
		]),
		getData() {
			this.getExtractedOutput({
				uuid: this.selectedFile.uuid,
				extractedOn: this.selectedFile.extractedOn,
			}).then(data => {
				if (data.ok) {
					this.tableLogResult = JSON.parse(JSON.stringify(data.data));
					this.editorHandler.setValue(JSON.stringify(data.data, null, 2));
				}
			});
		},
		onEditorCodeChange(code) {
			this.editorCode = code;
		},
		toggleLogDisplay() {
			this.editor = !this.editor;
		},
		editRow(rowItem) {
			let selectedRow = JSON.parse(JSON.stringify(rowItem));
			for (const rowKey of Object.keys(selectedRow)) {
				if (this.listOfHeadersAllowedToEdit.includes(rowKey)) {
					this.$set(
						this.selectedDataRowFieldsInfo,
						rowKey,
						selectedRow[rowKey]
					);
				}
				if (this.listOfVitalHeaders.includes(rowKey)) {
					this.$set(this.selectedDataRowVitalInfo, rowKey, selectedRow[rowKey]);
				}
			}
			this.formDialog = true;
		},
		closeModalAndClearState() {
			this.selectedDataRowFieldsInfo = {};
			this.selectedDataRowVitalInfo = {};
			this.formDialog = false;
		},
		handleSubmitClick() {
			let dataRow = JSON.parse(JSON.stringify(this.selectedDataRowFieldsInfo));

			this.openLoaderDialog();
			this.editExtractedDataRow({
				uuid: this.selectedDataRowVitalInfo.UUID,
				rowId: this.selectedDataRowVitalInfo._id,
				updateObj: {
					...dataRow,
				},
			}).then(data => {
				this.closeLoaderDialog();
				if (data.ok) {
					this.openSnackbar({
						text: data.message,
					});
				} else {
					this.openSnackbar({
						text: 'Failed to update the row. Try Again',
					});
					console.log(data.message);
				}
				this.closeModalAndClearState();
				this.getData();
			});
		},
		handleRowValidity() {
			if (
				window.confirm(
					`Are you sure you want to update the validity to ${
						this.rowValiditySelectionValue
					} for the selected _id's -> ${this.checkboxList.join(', ')}`
				)
			) {
				// API Call Here
				this.updateValidity({
					uuid: this.selectedFile.uuid,
					flag: this.rowValiditySelectionValue,
					rowIds: this.checkboxList,
				}).then(data => {
					if (data.ok) {
						this.checkboxList = [];
						this.openSnackbar({
							text: 'Sucessfully updated the selected Rows',
						});
						this.getData();
					}
				});
			}
		},
		selectSpecifiedRows() {
			let startValue = Number(this.rangeInput.startValue);
			let endValue = Number(this.rangeInput.endValue);

			if (startValue > endValue) {
				let temp = startValue;
				startValue = endValue;
				endValue = temp;
			}

			for (let i = startValue; i <= endValue; i++) {
				if (!this.checkboxList.includes(this.tableLogResult[i - 1]._id)) {
					this.checkboxList.push(this.tableLogResult[i - 1]._id);
				}
			}
		},
	},
	computed: {
		...mapGetters('reworkExtractedData', ['selectedFile']),
		...mapGetters(['getSelectedDates']),
		disableRangeButton() {
			if (
				/^-?\d*[.]?\d+$/.test(this.rangeInput.startValue) &&
				/^-?\d*[.]?\d+$/.test(this.rangeInput.endValue)
			) {
				return false;
			}
			return true;
		},
	},
	mounted() {
		this.getData();
	},
	watch: {},
	props: [],
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
.code {
	width: 100%;
	font-size: 14px;
	padding: 1%;
}
.mildRed {
	background: lightcoral;
}
.tableLight {
	display: table;
	text-align: center;
	width: 100%;
	margin: 1% auto 0;
	border-collapse: separate;
	/* font-family: 'Roboto', sans-serif; */
	font-weight: 400;
	/* padding: 1%; */
}
.tableDark {
	display: table;
	text-align: center;
	width: 100%;
	margin: 1% auto 0;
	border-collapse: separate;
	/* font-family: 'Roboto', sans-serif; */
	font-weight: 400;
	/* padding: 1%; */
}
.table_row {
	display: table-row;
}
.theader {
	display: table-row;
	text-align: left;
}
.table_header {
	padding-top: 10px;
	padding-left: 10px;
	padding-bottom: 10px;
	font-weight: 700;
}
.table_header_light {
	display: table-cell;
	border-bottom: #808080 1px solid;
	/* border-top:  1px solid; */
	background: #f0f0f0;
	color: #000;
}
.table_header_light:hover {
	cursor: pointer;
}
.table_header_dark:hover {
	cursor: pointer;
}
.table_header_dark {
	display: table-cell;
	border-bottom: #808080 1px solid;
	/* border-top:  1px solid; */
	background: #404040;
	color: #fff;
}
.table_small {
	display: table-cell;
}
.table_row > .table_small > .table_cell:nth-child(odd) {
	display: none;
	/* background: #bdbdbd; */
	/* color: #000; */
	padding-top: 3px;
	padding-bottom: 3px;
	min-width: 120px;
}
.table_row > .table_small > .table_cell {
	padding-top: 3px;
	padding-bottom: 3px;
	min-width: 120px;
	/* color: #000; */
	/* border-bottom: #808080 1px solid; */
}
@media screen and (max-width: 1200px) {
	.table {
		width: 100%;
	}
}
@media screen and (max-width: 700px) {
	.table {
		display: block;
		width: 100%;
	}
	.table_row:nth-child(2n + 3) {
		background: none;
	}
	.theader {
		display: none;
	}
	.table_row > .table_small > .table_cell:nth-child(odd) {
		display: table-cell;
		width: 50%;
	}
	.table_cell {
		display: table-cell;
		width: 50%;
	}
	.table_row {
		display: table;
		width: 100%;
		border-collapse: separate;
		padding-bottom: 20px;
		margin: 5% auto 0;
		text-align: center;
	}
	.table_small {
		display: table-row;
	}
	.table_row > .table_small:first-child > .table_cell:last-child {
		border-left: none;
	}
	.table_row > .table_small:last-child > .table_cell {
		border-bottom: #ccc 1px solid;
	}
	.table_row > .table_small > .table_cell:first-child {
		border-left: #ccc 1px solid;
	}
	.table_row > .table_small:first-child > .table_cell:first-child {
		border-top-left-radius: 5px;
		border-top: #ccc 1px solid;
	}
	.table_row > .table_small:first-child > .table_cell:last-child {
		border-top-right-radius: 5px;
		border-top: #ccc 1px solid;
	}
	.table_row > .table_small:last-child > .table_cell:first-child {
		border-right: none;
	}
	.table_row > .table_small > .table_cell:last-child {
		border-right: #ccc 1px solid;
	}
	.table_row > .table_small:last-child > .table_cell:first-child {
		border-bottom-left-radius: 5px;
	}
	.table_row > .table_small:last-child > .table_cell:last-child {
		border-bottom-right-radius: 5px;
	}
}

.input-field-wrapper {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;
	padding: 16px 0 !important;

	.input-field {
		flex: 0 0 46%;
	}
}
.dialog-title {
	color: white;
	background: linear-gradient(269deg, #1cb5e0 0%, #000851 100%);
}

.table_small.edit-button-container {
	position: sticky !important;
	z-index: 2;
	background: #f8f8f8;
	left: 0;
}
.table_small.flag-container {
	position: sticky !important;
	z-index: 2;
	background: #f8f8f8;
	left: 120px;
}
.extracted-data-table {
	height: 90vh;

	.theader {
		position: sticky;
		top: 0;
		z-index: 3;

		.table_header.edit-button-header {
			position: sticky;
			left: 0;
		}
		.table_header.flag-container-header {
			position: sticky;
			left: 120px;
		}
	}

	.tableLight {
		margin-top: 0;
	}
}

.range-selection-wrapper {
	padding: 8px;
	display: flex;
	justify-content: space-evenly;
	align-items: center;

	.selection-range-input-wrapper {
		display: flex;
		align-items: center;

		.v-input:not(:last-child) {
			margin-right: 10px;
		}
	}
}

.checkbox-item {
	padding-left: 16px;
}

.selection-type-wrapper {
	.v-btn--active {
		background-color: #64b5f6;
	}
}
</style>
